import { Component } from 'react';
import { connect } from 'react-redux';
import { actions, Form } from 'forms/rrf';
import ConfirmPopup from '../../../common/confirm-popup';
import RequiredInput from '../../../common/form/elements/required-input';

const model = 'deep.admin_decline_scan_orverride_dialog';

class DeclineScanOverrideDialog extends Component {
  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(actions.change(model, ''));
    dispatch(actions.reset(model));
  }

  render() {
    const {
      formValid, handleConfirmDialog
    } = this.props;

    return (
      <ConfirmPopup
        confirmLabel="Decline"
        header="DECLINE SCAN OVERRIDE REQUEST"
        confirmDisabled={!formValid}
        onClose={result => handleConfirmDialog(result)}
      >
        <div className="ta-left">
          <p>
            Please enter a reason for decline.
            The reason you enter below will be sent to the retailer and rep of the outlet requesting the scan override.
          </p>
          <Form model={model}>
            <RequiredInput
              controlId='decline_reason'
              model='.decline_reason'
            />
          </Form>
        </div>
      </ConfirmPopup>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.admin_decline_scan_orverride_dialog.$form.valid,
});

export default connect(mapStateToProps)(DeclineScanOverrideDialog);
